import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { JwtHelper } from "angular2-jwt";
import { LocalStorageService } from './local-storage.service';
import { GenericHttpService } from "./generic-http.service";
import { environment } from "../../../environments/environment";
import { SettingsConstant } from './../constants/settings.constants';
import { Observable, from } from "rxjs";
import { ApiUrlConstant } from "../constants/api-url.constant";
import { Router } from "@angular/router";
import { GenericUtils } from "./../../shared/utilities";
import { PermissionUrlService } from './permissions.service';

@Injectable({
  providedIn: "root"
})
export class CommonService {
  jwtHelper: JwtHelper = new JwtHelper();
  queryString = '';
  paramObj = {
    origin_fc_type: '',
    origin_fc_client_name: '',
    business_division: '',
    product_category: '',
    product_sku: '',
    external_bucket: '',
    page_offset: '',
    page_number: '',
    tab: '',
    tf: '',
  }
  constructor(
    private localStorage?: LocalStorageService,
    private generic?: GenericHttpService,
    private apiUrlConst?: ApiUrlConstant,
    private router?: Router,
    private utils?: GenericUtils,
    private permissions?: PermissionUrlService,
  ) { }
  apiUrl = environment.baseUrl;
  perm: Array<String> = [];

  getUserClientMapping() {
    const option = {
      method: "GET",
      url: `${environment.gateWayHost}${this.apiUrlConst.GET_USER_CLIENTS}`
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData));
  }

  getCookie(name) {
    const cookieName = name + '=',
      ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(cookieName) === 0) {
        const cookieValue = c.substring(cookieName.length, c.length);
        try {
          if (JSON.parse(cookieValue)) {
            return JSON.parse(cookieValue);
          }
        } catch (e) {
          return cookieValue;
        }
      }
    }
    return null;
  }

  getSelfProfile() {
    const option = {
      url: `${environment.UMS_HOST}${this.apiUrlConst.GET_SELF_PROFILE}`,
      method: 'GET'
    }
    return this.generic.httpRequest(option)
      .pipe(
        catchError(this.generic.handleError),
        map(this.generic.responseData)
      );
  }

  getSelfScopes() {
    const option = {
      url: `${environment.UMS_HOST}${this.apiUrlConst.GET_SELF_SCOPES}`,
      method: 'GET',
      query: ''
    }
    return this.generic.httpRequest(option)
      .pipe(
        catchError(this.generic.handleError),
        map(this.generic.responseData)
      );
  }

  getData(option) {
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }

  downloadReport(options) {
    return this.generic.httpRequest(options).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }

  getEmailId() {
    const userDetails = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS
    );
    const email = userDetails && userDetails['email'] ? userDetails['email'] : false;
    return email;
  }
  getDownloadLink(param): Observable<any> {
    const config = {
      method: "GET",
      url: `${environment.gateWayHost}${this.apiUrlConst.MOVEMENT_DETAILS_GET_DOCUMENT}`,
      query: param
    };
    return this.generic
      .httpRequest(config)
      .pipe(catchError(this.generic.handleError));
  }
  settingFormater(string) {
    const lastIndex = string ? string.substring(0, 7) + '...' : '';
    if (string && string.length > 7) {
      return lastIndex
    } else {
      return string
    }
  }

  passToQueryParams(params) {
    const paramsList = Object.keys(this.paramObj);
    paramsList.map(ele => {
      this.paramObj[ele] = '';
    })
    Object.keys(params).map(ele => {
      this.paramObj[ele] = params[ele];
      if (ele === 'external_bucket') {
        delete this.paramObj[ele];
      }else if (ele === 'order_status') {
        delete this.paramObj[ele];
      }
    })
    const q_string = this.utils.cleanParameters(this.paramObj);
    this.router.navigate([], { queryParams: q_string, })
  }

  getFiltersParams(source, destination) {
    Object.keys(destination).forEach(element => {
      destination[element] = '';
    });
    Object.keys(source).forEach(element => {
      destination[element] = source[element];
    });
    return this.utils.cleanNullKeys(destination);
  }

  isObject(obj) {
    const type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  deepCopy(src) {
    const target = {};
    for (const prop in src) {
      if (src.hasOwnProperty(prop)) {
        // if the value is a nested object, recursively copy all it's properties
        if (this.isObject(src[prop])) {
          target[prop] = this.deepCopy(src[prop]);
        } else {
          target[prop] = src[prop];
        }
      }
    }
    return target;
  }
  numberWithCommas(x) {
    if (typeof (x) != 'number') return x
    const parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  getTabPermissions(tabValue, navUrl) {

    this.redirectToTab(this.perm, tabValue, navUrl)
  }

  checkpermission(url) {
    const tabValue: any = {
      deliveryTab: '',
      transferTab: '',
      inwardTab: '',
      returnTab: ''
    }
    let navUrl = '';
    // 666 Just use local storage
    const scopes = this.localStorage.getItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_SCOPES}`);
    this.perm = scopes || [];

    let activeTabPerm: any[];
    if (url.split('/')[1] === 'movementdetailsdashboard') {
      navUrl = url.split('/')[1]
      tabValue.deliveryTab = this.permissions.MOVEMENT_DETAIL_DELIVERY_TAB;
      tabValue.transferTab = this.permissions.MOVEMENT_DETAIL_TRANSFER_TAB;
      tabValue.inwardTab = this.permissions.MOVEMENT_DETAIL_INWARD_TAB;
      tabValue.returnTab = this.permissions.MOVEMENT_DETAIL_RETURN_TAB;
      if (url.split('/')[2] === "delivery") {
        activeTabPerm = this.permissions.MOVEMENT_DETAIL_DELIVERY_TAB;
      } else if (url.split('/')[2] === "transfer") {
        activeTabPerm = this.permissions.MOVEMENT_DETAIL_TRANSFER_TAB;
      } else if (url.split('/')[2] === "inward") {
        activeTabPerm = this.permissions.MOVEMENT_DETAIL_INWARD_TAB;
      } else if (url.split('/')[2] === "return") {
        activeTabPerm = this.permissions.MOVEMENT_DETAIL_RETURN_TAB;
      }
    }

    if (url.split('/')[1] === 'performance') {
      navUrl = url.split('/')[1]
      tabValue.deliveryTab = this.permissions.OVERALL_PERFORMANCE_TAB_DELHIVERY;
      tabValue.transferTab = this.permissions.OVERALL_PERFORMANCE_TAB_TRANSFER;
      tabValue.inwardTab = this.permissions.OVERALL_PERFORMANCE_TAB_INWARD;
      tabValue.returnTab = this.permissions.OVERALL_PERFORMANCE_TAB_RETURN;
      if (url.split('/')[2] === "delivery") {
        activeTabPerm = this.permissions.OVERALL_PERFORMANCE_TAB_DELHIVERY;
      } else if (url.split('/')[2] === "transfer") {
        activeTabPerm = this.permissions.OVERALL_PERFORMANCE_TAB_TRANSFER;
      } else if (url.split('/')[2] === "inward") {
        activeTabPerm = this.permissions.OVERALL_PERFORMANCE_TAB_INWARD;
      } else if (url.split('/')[2] === "return") {
        activeTabPerm = this.permissions.OVERALL_PERFORMANCE_TAB_RETURN;
      }
      else {
        this.redirectToTab(this.perm, tabValue, navUrl)
        return
      }
    }
    if (activeTabPerm) {
      if (activeTabPerm.some(elem => this.perm.indexOf(elem) > -1)) {
        return
      } else {
        this.getTabPermissions(tabValue, navUrl)
      }
    }

    if (url.split('/')[1] === 'warehousedashboard') {
      navUrl = url.split('/')[1];
      const newTabValue = {};
      newTabValue['outboundTab'] = this.permissions.WAREHOUSE_OUTBOUND;
      newTabValue['inboundTab'] = this.permissions.WAREHOUSE_INBOUND;
      //newTabValue['inventoryTab'] = this.permissions.WAREHOUSE_INVENTORY;

      //tabValue.inventoryTab = this.permissions.OVERALL_PERFORMANCE_TAB_INWARD;
      if (url.split('/')[2] === "outbound") {
        activeTabPerm = this.permissions.WAREHOUSE_OUTBOUND;
      } else if (url.split('/')[2] === "inbound") {
        activeTabPerm = this.permissions.WAREHOUSE_INBOUND;
      } else if (url.split('/')[2] === "inventory") {
       // activeTabPerm = this.permissions.WAREHOUSE_INVENTORY;
      }
      if (activeTabPerm) {
        if (activeTabPerm.some(elem => this.perm.indexOf(elem) > -1)) {
          return
        } else {
          this.redirectToTabNew(this.perm, newTabValue, navUrl, ['outbound', 'inbound', 'inventory']);

        }
      }
    }






  }

  redirectToTabNew(userPermissions, tabPermissions, baseUrl, joinUrl) {
    const permissionsKeys = Object.keys(tabPermissions);

    for (let i = 0; i < permissionsKeys.length; i++) {
      if (tabPermissions[permissionsKeys[i]]) {
        if (tabPermissions[permissionsKeys[i]].some(elem => userPermissions.indexOf(elem) > -1)) {
          this.router.navigate([`/${baseUrl}/${joinUrl[i]}`], { replaceUrl: true });
          return false;
        } 
      }
    };

      this.router.navigate(["/forbidden"], { replaceUrl: true });
      return false;
  }

  redirectToTab(scope, tabValue, Param) {
    const userPermissions = scope;
    const Delivery = tabValue['deliveryTab'];
    const Transfer = tabValue['transferTab'];
    const Inward = tabValue['inwardTab'];
    const Return = tabValue['returnTab'];
    if (Delivery.some(elem => userPermissions.indexOf(elem) > -1)) {
      this.router.navigate([`/${Param}/delivery`], { replaceUrl: true });
      return false;
    } else if (Transfer.some(elem => userPermissions.indexOf(elem) > -1)) {
      this.router.navigate([`/${Param}/transfer`], { replaceUrl: true });
      return false;
    } else if (Inward.some(elem => userPermissions.indexOf(elem) > -1)) {
      this.router.navigate([`/${Param}/inward`], { replaceUrl: true });
      return false;
    } else if (Return.some(elem => userPermissions.indexOf(elem) > -1)) {
      this.router.navigate([`/${Param}/return`], { replaceUrl: true });
      return false;
    }
    else {
      this.router.navigate(["/forbidden"], { replaceUrl: true });
      return false;
    }
  }
}
